import { formatDate } from '@shared/services/dateService';

const LegalDocumentsMapper = {
  toDataPage: legalDocumentsData => {
    return legalDocumentsData.legalDocuments.map(legalDocument => ({
      id: legalDocument.Id,
      orgId: legalDocument.OrgId,
      completedDate: legalDocument.CompletedDate,
      orgUnits: getOrgUnitNames(legalDocument, legalDocumentsData.mddapOrganization),
      fileName: legalDocument.FileName
    }));
  },

  toApolloInput: legalDocument => ({
    CompletedDate: formatDate(legalDocument.completedDate),
    OrgUnitIds: legalDocument.orgUnitIds.map(orgUnit => orgUnit),
    FileName: legalDocument.file.name
  })
};

const getOrgUnitNames = (legalDocument, organization) =>
  legalDocument.LegalDocumentOrgUnits.map(
    ldou => organization?.MddapOrgUnits.find(ou => ou.Id === ldou.OrgUnitId)?.Name
  ).join(', ');

export default LegalDocumentsMapper;
